export const dataHooks = {
    radarChartScaleLine: 'radarChart-scaleLine',
    radarChartDataItem: 'radarChart-dataItem',
};
//# sourceMappingURL=constants.js.map